export default function initGsap($) {
  /* ========================================================================= *\
  **  === GSAP                                                                 *| 
  \* ========================================================================= */
  
  gsap.registerPlugin(ScrollTrigger);
  gsap.registerPlugin(DrawSVGPlugin);


  if($('.parallax-bg').length) {
    gsap.utils.toArray(".parallax-bg").forEach(function (elem) {
      gsap.to(elem, {
        scrollTrigger: {
          trigger: elem,
          scrub: true,
          start: "top",
          // end: "bottom bottom",
          // markers: true,
        },
        yPercent: 20
      });
    });
  }

  if($('.hero--img').length) {
    gsap.from(".hero--img", {
      duration: 1,
      scale: 1.13,
    });
    gsap.to(".hero--img", {
      delay: .4,
      duration: 10,
      scale: 1.02,
      // yPercent: 0 
    });
    $('.hero--slider-bgi').on('beforeChange', function(){
      gsap.to(".hero--img", {
        duration: .5,
        scale: 1.13
      });
      gsap.to(".hero--img", {
        delay: .4,
        duration: 10,
        scale: 1.02
      });
    });
  }

  if($('.parallax-bottom-10').length) {
    gsap.utils.toArray(".parallax-bottom-10").forEach(function (elem) {
      gsap.to(elem, {
        scrollTrigger: {
          trigger: elem,
          scrub: 2,
          // markers: true,
        },
        ease: "none",
        yPercent: 10
      });  
    });
  }

  if($('.parallax-pictodeco').length) {
    gsap.utils.toArray(".parallax-pictodeco").forEach(function (elem) {
      gsap.to(elem, {
        scrollTrigger: {
          trigger: elem,
          scrub: true,
          // markers: true,
          start: "-500px", // when the top of the trigger hits the top of the viewport
          end: "+=1500", // end after scrolling 500px beyond the start
        },
        ease: "none",
        yPercent: 40
      });  
    });
  }

  if($('.parallax-top-10').length) {
    gsap.utils.toArray(".parallax-top-10").forEach(function (elem) {
      gsap.to(elem, {
        scrollTrigger: {
          trigger: elem,
          scrub: 2,
          // markers: true,
        },
        ease: "none",
        yPercent: -10
      });  
    });
  }

  if($('.parallax-5-bottom').length) {
    gsap.utils.toArray(".parallax-5-bottom").forEach(function (elem) {
      gsap.to(elem, {
        scrollTrigger: {
          trigger: elem,
          scrub: 2,
          // markers: true,
        },
        // ease: "none",
        y: -50
      });
    });
  }

  if($('.parallax-top-20').length) {
    gsap.utils.toArray(".parallax-top-20").forEach(function (elem) {
      gsap.to(elem, {
        scrollTrigger: {
          trigger: elem,
          scrub: 2,
          // markers: true,
        },
        ease: "none",
        yPercent: 20
      });  
    });
  }

  if($('.parallax-left-10').length) {
    gsap.utils.toArray(".parallax-left-10").forEach(function (elem) {
      gsap.to(elem, {
        scrollTrigger: {
          trigger: elem,
          scrub: 2,
          // markers: true,
        },
        ease: "none",
        xPercent: -5
      });  
    });
  }

  if($('.parallax-right-10').length) {
    gsap.utils.toArray(".parallax-right-10").forEach(function (elem) {
      gsap.to(elem, {
        scrollTrigger: {
          trigger: elem,
          scrub: 2,
          // markers: true,
        },
        ease: "none",
        xPercent: 5
      });  
    });
  }

  var alreadyPlayed = Cookies.get('loadPage');
  if(!alreadyPlayed){
    // $(".loadPage").addClass('is-active');
    if($('.draw').length) {
      var tl = gsap.timeline();
      gsap.set(".logo", {opacity:1} );
      tl.from(".draw", { duration: 30, drawSVG: 0, ease: "power3.out" } )
        .to('.draw', { duration: 0.5, fill: "#fff" }, "<1.8")
        .call( function(){ $(".loadPage").removeClass('is-active'); Cookies.set('loadPage', 'is-off') }, null, "<1.5")
    }
  } else {
    $(".loadPage").removeClass('is-active');
  }

  
  gsap.to('.zoom', {
    scale: 1.2,
    duration: 20,
  });
}
